var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameCategoryBigbills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4233.32 4233.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "M994.17 833.84l2886.38 0 0 1924.26 -2886.38 0 0 -1924.26 0 0zm1443.22 481.03c265.64,0 481.09,215.46 481.09,481.1 0,265.57 -215.45,481.03 -481.09,481.03 -265.64,0 -481.03,-215.46 -481.03,-481.03 0,-265.64 215.39,-481.1 481.03,-481.1l0 0zm-801.83 -160.3c0.13,177.09 -143.51,320.73 -320.6,320.73l-0.06 641.4c177.15,-0.12 320.79,143.51 320.79,320.6l1603.46 0.07c0,-177.16 143.64,-320.79 320.73,-320.79l0 -641.34c-177.09,0.06 -320.73,-143.58 -320.73,-320.67l-1603.59 0 0 0zm-1282.79 320.67l320.67 0 0 1603.59 2565.71 0 0 320.66 -2886.38 0 0 -1924.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameCategoryBigbills);
export default __webpack_public_path__ + "static/media/icon-game-category-bigbills.90a331dc66a748248ef3766eee426055.svg";
export { ForwardRef as ReactComponent };